import React from "react";

const BillingInformationHeaderDescription = (props: { message: string }) => {
    return (
        <React.Fragment>
            <div className="box-description">
                <p>{props.message}</p>
            </div>
        </React.Fragment>
    );
};

export default BillingInformationHeaderDescription;
